import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';

import { typography } from '~/src/styles/design-system';
import { resetStyles } from '~/src/styles/reset-styles-mixins';
import { breakpoints } from '~/src/styles/styled-mixins';
import { fontWeight } from '~/src/styles/styled-variables';

import { ReactComponent as Checkmark } from './checkmark.svg';

const styles = {
  text: css(resetStyles.heading, {
    color: 'var(--Grey-Text, #585858)',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: fontWeight.medium,
    lineHeight: '22px',
    letterSpacing: '0.7px',
    [breakpoints.minTablet]: typography.bodyText,
    [breakpoints.minDesktop]: {
      color: 'var(--Grey-Text, #585858)',
      fontSize: '24px',
      fontWeight: '500',
      lineHeight: '40px',
      letterSpacing: '1.2px',
    },
  }),
  checkmark: css({
    height: '16px',
  }),
  container: css({
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    [breakpoints.minTablet]: {
      gap: '16px',
    },
  }),
};

export const Benefit: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div css={styles.container}>
      <Checkmark css={styles.checkmark} />
      <h3 css={styles.text}>{children}</h3>
    </div>
  );
};
